export const CSSO_PROVIDERS_NAMES = ["github", "google"];
